import Text from "@amzn/meridian/text";
import { useLocation } from "react-router-dom";
import { useAppSelector } from "src/store/store";
import Chat from "./components/chat/chat";
import "./home.scss";
import { Column, Row } from "@amzn/meridian";
import { HOMEPAGE_DESCRIPTION } from "src/constants/constants";

const HomePage = () => {
  const location = useLocation();
  const { firstName } = useAppSelector((state) => state.user);
  const { showResult } = useAppSelector((state) => state.chatSlice);
  const isOnMcpRoute = location.pathname === "/mcp";

  return (
    <Row>
      <Row width={"100%"} alignmentHorizontal="center">
        <Column spacingInset={"none 600"} maxWidth={898}>
          <Column spacing={"500"}>
            {!showResult && (
              <Column spacingInset={"600 none none none"}>
                <Column spacing={"none"} spacingInset={"600 none none none"}>
                  <Text
                    fontFamily="bookerly"
                    type="d50"
                    className="greet-username"
                  >
                    Hello {firstName}!
                  </Text>
                  <Text fontFamily="bookerly" type="d50">
                    How can we help you today?
                  </Text>
                </Column>
                <Text type="b200" color="secondary">
                  {HOMEPAGE_DESCRIPTION}
                  <a
                    href="https://w.amazon.com/bin/view/Whs/Programs/Procedures"
                    target="_blank"
                    rel="noreferrer"
                  >
                    here
                  </a>
                  .
                </Text>
              </Column>
            )}
            <div className="home">
              <Column className="home__min-container">
                <Chat isOnMcpRoute={isOnMcpRoute} />
              </Column>
            </div>
          </Column>
        </Column>
      </Row>
    </Row>
  );
};

export default HomePage;
